import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/tailwind.css'
import '@arcanecircle/ui/styles'
import './styles/vtt-shell.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary label="root">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
